
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success: 
          "border-transparent bg-green-100 text-green-800 hover:bg-green-200",
        warning: 
          "border-transparent bg-yellow-100 text-yellow-800 hover:bg-yellow-200",
        info: 
          "border-transparent bg-blue-100 text-blue-800 hover:bg-blue-200",
        purple: 
          "border-transparent bg-purple-100 text-purple-800 hover:bg-purple-200",
        admin:
          "border-transparent bg-destructive/90 text-destructive-foreground shadow-sm hover:bg-destructive",
        user:
          "border-transparent bg-slate-100 text-slate-800 hover:bg-slate-200",
      },
      size: {
        default: "px-2.5 py-0.5 text-xs",
        sm: "px-2 py-0.5 text-[10px]",
        lg: "px-3 py-1 text-sm",
      },
      withIcon: {
        true: "pl-2",
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      withIcon: false,
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, withIcon, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size, withIcon }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
